import { AuthRoles } from '@hefe/auth';
import { AiOutlineUser } from 'react-icons/ai';
import { FiSettings } from 'react-icons/fi';

export default {
  items: [
    {
      name: 'profile',
      url: '/user/profile',
      icon: AiOutlineUser,
      auth: AuthRoles.bbuser,
    },
    {
      name: 'inventory.plural',
      url: '/user/inventories',
      icon: AiOutlineUser,
      auth: AuthRoles.bbuser,
    },
    {
      name: 'settings.title',
      url: '/user/settings',
      icon: FiSettings,
      auth: AuthRoles.bbuser,
    },
  ],
};
